import { Popover } from "tamagui";
import { LmSheet } from "./LmSheet";
import { jsx, jsxs } from "react/jsx-runtime";
function LmPopover({
  trigger,
  children,
  hideArrow,
  contentProps,
  isBouncy = !0,
  sheetProps,
  ...popoverProps
}) {
  return /* @__PURE__ */ jsxs(Popover, { size: "$5", ...popoverProps, children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { asChild: !0, children: trigger }),
    /* @__PURE__ */ jsx(Popover.Adapt, { when: "sm", platform: "touch", children: /* @__PURE__ */ jsx(LmSheet, { ...sheetProps, children: /* @__PURE__ */ jsx(Popover.Adapt.Contents, {}) }) }),
    /* @__PURE__ */ jsxs(
      Popover.Content,
      {
        borderWidth: 1,
        borderColor: "$borderColor",
        ...isBouncy && {
          enterStyle: { x: 0, y: -10, opacity: 0 },
          exitStyle: { x: 0, y: -10, opacity: 0, pointerEvents: "none" },
          x: 0,
          y: 0,
          o: 1,
          animation: [
            "quick",
            {
              opacity: {
                overshootClamping: !0
              }
            }
          ]
        },
        elevate: !0,
        padding: contentProps?.padding || 0,
        ...contentProps,
        children: [
          !hideArrow && /* @__PURE__ */ jsx(Popover.Arrow, { borderWidth: 1, borderColor: "$borderColor" }),
          children
        ]
      }
    )
  ] });
}
export {
  LmPopover
};
//# sourceMappingURL=LmPopover.js.map
